import { ButtonBase, FormLabel, Grid } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';
import { FC, useMemo, useState } from 'react';
import { DatePattern } from 'utils/constant';

import './DateRangePicker.css';

import CustomPickerDay, { DateRangeValue } from './CustomPickerDate';

interface DateRangePickerProps {
  id?: string;
  label?: string;
  required?: boolean;
  startDate?: string;
  endDate?: string;
  isRow?: boolean;
  placeholder?: string;
  onChange: (start: string, end: string) => void;
  format?: string;
  // isShowClear?: boolean;
}

const AppDateRangePicker: FC<DateRangePickerProps> = ({
  id,
  label,
  required,
  startDate,
  endDate,
  isRow = false,
  placeholder,
  format,
  onChange,
  // isShowClear,
}) => {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState<DateRangeValue>({
    start: startDate ? dayjs(startDate) : null,
    end: endDate ? dayjs(endDate) : null,
  });
  const [tempValue, setTempValue] = useState(value);

  const valueText = useMemo(() => {
    let text = '';
    if (value.start && value.end) {
      text =
        dayjs(value.start).format(format) +
        ' ~ ' +
        dayjs(value.end).format(format);
    }
    return text;
  }, [value]);

  const handleSelect = (date: Dayjs) => {
    value.start = date;
    value.end = dayjs(date).add(6, 'day');
    setTempValue({ ...value });
    onChange?.(
      dayjs(value.start).format(DatePattern.DATE),
      dayjs(value.end).format(DatePattern.DATE)
    );
    setOpen(false);
    setValue({ ...value });
  };

  const handleClose = () => {
    if (!value.end) {
      setValue({ ...tempValue });
    }
    setOpen(false);
  };

  // const onClear = () => {
  //   value.start = null;
  //   value.end = null;
  //   setValue({ ...value });
  //   onChange('', '');
  // };

  return (
    <Grid
      container
      className='DateRangePicker'
      direction={isRow ? 'row' : 'column'}
      spacing={isRow ? 3 : 2}
    >
      {label && (
        <FormLabel htmlFor={id} required={required}>
          {label}
        </FormLabel>
      )}
      <Grid item xs={8}>
        <ButtonBase
          className='DateRangePickerCalendar'
          disableTouchRipple
          disabled={open}
          onClick={() => setOpen(true)}
        >
          <DatePicker
            closeOnSelect={false}
            open={open}
            desktopModeMediaQuery='(min-width:0px)'
            slotProps={{
              textField: {
                className: valueText ? 'MuiFormControl-filled' : '',
                placeholder: valueText || placeholder,
                value: null,
                inputProps: {
                  sx: {
                    padding: '12.07px !important',
                  },
                },
              },
              toolbar: { hidden: true },
              actionBar: { actions: [] },
            }}
            slots={{
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              day: (pickerProps: any) => {
                return (
                  <CustomPickerDay
                    {...pickerProps}
                    range={value}
                    onClick={() => handleSelect(pickerProps.day)}
                  />
                );
              },
            }}
            sx={{
              '& .MuiSvgIcon-root': {
                fontSize: '25px !important',
              },
            }}
            onClose={handleClose}
          />
        </ButtonBase>
      </Grid>
    </Grid>
  );
};

export default AppDateRangePicker;
